import logo from '../../assets/sgokit.svg';

/**
 * The platform domain's root while the marketing home (`Home.tsx`) is on hold:
 * the logo and nothing else. Both "no tenant in context" fallbacks
 * (RootRedirect, TenantPage) render this; the rest of the platform pages are
 * still routed, just not linked from here. Swap those two imports back to
 * `./Home` to restore the full page.
 */
export default function PlatformLanding() {
  return (
    <main
      data-testid="platform-landing"
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#fff',
      }}
    >
      <img
        src={logo}
        alt="SGOKit"
        data-testid="platform-landing-logo"
        style={{ width: 'min(220px, 50vw)', height: 'auto' }}
      />
    </main>
  );
}
